import { useAuth } from 'src/common/razzle-platform-user/Authentication'
import { useIntl } from 'src/common/razzle-platform-translate'
import { BASE_URL, RIGHT_MESSAGE_UUID } from 'src/configs'

export const useMessaging = (userId) => {
    const { onAuth }: any = useAuth()
    const { formatMessage } = useIntl()

    const handleSendMessageClick = (event) => {
        event.preventDefault()
        const authorization: any = {
            requiredRight: RIGHT_MESSAGE_UUID,
            description: formatMessage({
                id: 'Pour utiliser la conversation, vous devez être abonné',
                defaultMessage: 'Pour utiliser la conversation, vous devez être abonné',
            }),
            buttonTitle: formatMessage({ id: 'Abonnez-vous maintenant', defaultMessage: 'Abonnez-vous maintenant' }),
            redirectTo: `${BASE_URL}app/product-salable`,
        }
        onAuth((usr) => {
            if (usr.id !== userId) {
                window.location.href = `${BASE_URL}app/chat?user=${userId}`
            }
        }, authorization)
    }

    return {
        handleSendMessageClick,
    }
}
